import { InvitationStatus, UserStatus } from '@avanzu/types';
export const getStatusColor = (status: InvitationStatus | UserStatus) => {
  switch (status) {
    case InvitationStatus.PENDING:
    case UserStatus.PENDING:
      return 'warning.light';
    case InvitationStatus.ACCEPTED:
    case UserStatus.ACTIVE:
      return 'success.light';
    case InvitationStatus.EXPIRED:
    case UserStatus.INACTIVE:
      return 'error.light';
    case InvitationStatus.CANCELLED:
      return 'default';
    default:
      return 'default';
  }
};

export default getStatusColor;
